import { render, staticRenderFns } from "./AddRate.vue?vue&type=template&id=47ccf814&scoped=true&"
import script from "./AddRate.vue?vue&type=script&lang=js&"
export * from "./AddRate.vue?vue&type=script&lang=js&"
import style0 from "./AddRate.vue?vue&type=style&index=0&id=47ccf814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccf814",
  null
  
)

component.options.__file = "AddRate.vue"
export default component.exports